export default __webpack_public_path__ + "58cfed974776ac8a43a28e62945c1bb4.png";